/**
 * Inventario del usuario autenticado.
 */
import { api } from "./client";

export interface InventoryRow {
  sticker_id: number;
  count: number;
}

export interface AlbumStats {
  owned: number;
  dups: number;            // total de copias extra (sum count-1)
  dups_unique: number;     // láminas distintas que están en duplicado
  missing: number;
  total: number;
  pct: number;
}

export async function fetchMyInventory(): Promise<InventoryRow[]> {
  return api<InventoryRow[]>("/inventory/me");
}

export async function setOwnership(stickerId: number, count: number): Promise<InventoryRow> {
  return api<InventoryRow>("/inventory/me", {
    method: "PUT",
    body: JSON.stringify({ sticker_id: stickerId, count }),
  });
}

export async function fetchMyStats(): Promise<AlbumStats> {
  return api<AlbumStats>("/inventory/me/stats");
}

export interface TeamProgress {
  team_id: number;
  team_code: string;
  team_name: string;
  team_color: string;
  total: number;
  owned: number;
  dups: number;
  missing: number;
  pct: number;
}

export async function fetchMyTeamStats(): Promise<TeamProgress[]> {
  return api<TeamProgress[]>("/inventory/me/by-team");
}
